import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";

const TONE = {
  active: "success",
  inactive: "default",
  pending: "warning",
  success: "success",
  failed: "error",
  error: "error",
};

/** Small status pill — replaces MD2's MDBadge in Cell renderers. */
function StatusChip({ value, color }) {
  const resolvedColor = color || TONE[String(value).toLowerCase()] || "default";
  return (
    <Chip
      label={value}
      color={resolvedColor}
      size="small"
      sx={{ textTransform: "capitalize", fontWeight: 600 }}
    />
  );
}

StatusChip.propTypes = {
  value: PropTypes.node.isRequired,
  color: PropTypes.string,
};

export default StatusChip;
